<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="25%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                    <v-container>
                        <v-row class="pa-2">
                            <p>{{ displayGolfCourseName }}</p>
                        </v-row>
                        <v-row class="pa-2">
                            <p>{{ propsPlanName }}</p>
                        </v-row>
                    </v-container>
                    <v-form
                        ref="form"
                        >
                        <v-select
                            class="px-3 mb-2"
                            :items="propsCourse"
                            item-value="course_code"
                            item-text="course_name"
                            v-model="input.courseValue"
                            label="コースを選択"
                            hide-details
                            width="100px"
                            :rules='[rules.required]'
                            />
                            <v-text-field
                                class="px-3"
                                type="time"
                                placeholder="00:00"
                                label="開始時刻"
                                v-model="input.startTime"
                                :rules='[rules.required]'
                            />
                            <v-text-field
                                class="px-3"
                                type="time"
                                placeholder="00:00"
                                label="終了時刻"
                                v-model="input.endTime"
                                :rules='[rules.required, rules.correctTime]'
                            />
                    </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                    <v-btn color="green darken-4" text @click="validateCheck">登録</v-btn>
                </v-card-actions>
                <AddOverLay
                    page-name="枠連携"
                    @processing="registPlanTime"
                    @cancel="closeAddOverLay"
                    :process-result="process"
                    :OverlaySwitch="addOverlay"
                />
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import { authorityMixin } from '@/views/authorityMixin';
import {
    // GET_PLAN_BENEFIT,
    REGIST_PLAN_TIME } from '@/constants/plan';
import AddOverLay from '@/components/overlay/AddOverlay';
import { SYNC_PLAN_CELLS } from '@/constants/cell_info';

export default {
    components: {
        CardTitle,
        AddOverLay
    },
    mixins: [authorityMixin],
    props: [
        'dialog',
        'displayGolfCourse',
        'displayGolfCourseName',
        'propsCourse',
        'propsPlanId',
        'propsPlanName'
    ],
    data () {
        return {
            // 追加確認用ポップアップ表示に関する制御値
            addOverlay: false,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // 入力値
            input: {
                courseValue: '',
                startTime: '',
                endTime: ''
            },
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '枠連携時間',
            rules: {
                // 必須項目
                required: value => !!value || this.$t('error.validation.required.any'),
                // 氏名（姓）バリデーション
                // correctDate: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),

                correctTime: value => this.timeCorrected(value) || this.$t('error.validation.time.correct')
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '変更', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: ''
        };
    },
    methods: {
        /** ----------------------------------------------
         * 終了時刻が開始時刻より大きい
         * ---------------------------------------------- */
        timeCorrected () {
            if (this.input.startTime && this.input.endTime) {
                return Number(this.input.startTime.replace(/:/g, '')) < Number(this.input.endTime.replace(/:/g, ''));
            }
        },
        /** ----------------------------------------------
         * 特典の登録処理
         * ---------------------------------------------- */
        registPlanTime () {
            this.$apollo.mutate({
                mutation: REGIST_PLAN_TIME,
                variables: {
                    plan_id: this.propsPlanId,
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.displayGolfCourse,
                    course_code: this.input.courseValue,
                    play_start: this.input.startTime,
                    play_end: this.input.endTime
                }
            }).then(res => {
                const data = res.data.registPlanTime.result;
                if (data === 1) {
                    this.syncPlanCells();
                    this.closeAddOverLay();
                    this.CloseModal();
                } else if (data === 0) {
                    const resultText = '同じ時間が登録されています。';
                    throw new Error(resultText);
                }
            }).catch(error => {
                error = error.message.split(/:/g);
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error[1]);
            });
        },
        syncPlanCells () {
            return this.$apollo.mutate({
                mutation: SYNC_PLAN_CELLS,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.displayGolfCourse,
                    plan_id: this.propsPlanId
                }
            }).then(res => {
                const result = res.data.SyncPlanCells.result;
                return result;
            });
        },
        /** ----------------------------------------------
         * チェック処理
          ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                this.displayAddOverLay();
            }
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            this.addOverlay = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる処理
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.addOverlay = false;
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.$set(this.input, 'courseValue', '');
            this.$set(this.input, 'startTime', '');
            this.$set(this.input, 'endTime', '');
            this.$refs.form.resetValidation();
            this.$emit('close');
        }
    }
};
</script>
